const trades = [
  { icon: 'ri-temp-hot-line', label: 'HVAC' },
  { icon: 'ri-drop-line', label: 'Plumbing' },
  { icon: 'ri-home-3-line', label: 'Roofing' },
  { icon: 'ri-flashlight-line', label: 'Electrical' },
  { icon: 'ri-tools-line', label: 'Trade Contractors' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#060A14] border-b border-white/6 py-6">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-center gap-5">
          <span className="text-white/20 text-[10px] font-semibold tracking-[0.2em] uppercase whitespace-nowrap font-inter">Serving</span>
          <div className="w-px h-4 bg-white/10 hidden sm:block"></div>
          <div className="flex flex-wrap justify-center sm:justify-start items-center gap-2">
            {trades.map((t) => (
              <div
                key={t.label}
                className="flex items-center gap-2 bg-white/5 border border-white/8 rounded-full px-4 py-1.5 hover:bg-white/8 transition-colors duration-200"
              >
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={`${t.icon} text-white/50 text-xs`}></i>
                </div>
                <span className="text-white/50 text-xs font-medium whitespace-nowrap font-inter">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
